import React, { useEffect, useState, Fragment } from "react";
import { Typography, makeStyles, Grid, Button } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
//theme
import Theme, { useStyles } from "../../../../Theme.js";
//images
import CONTE_LEGENDE from "../../../../../images/pictos-ok/CONTE_LEGENDE.svg";
import GASTRONOMIE from "../../../../../images/pictos-ok/GASTRONOMIE.svg";
import LANGUE_REGIONALE from "../../../../../images/pictos-ok/LANGUE REGIONALE.svg";
import FETE_TRADITIONNELLE from "../../../../../images/pictos-ok/FETE_TRADITIONNELLE.svg";
import MARCHE from "../../../../../images/pictos-ok/MARCHE.svg";
import AUTRE from "../../../../../images/pictos-ok/AUTRE.svg";

import { Panorama } from "@material-ui/icons";
const Step1 = (props) => {
  const classes = useStyles();
  const [affichage, setAffichage] = useState(false);

  useEffect(() => {
    // Quand le composant se charge, n'autorise pas à passer à la suite
    // Quand le composant se charge, bloque la possibilité de passer sans répondre
    if (props.result.sujet) {
      setAffichage(props.result.sujet);
      document.querySelector('[sujet="' + props.result.sujet + '"]').focus();
      props.setAuthorization(true);
    } else {
      // Quand le composant se charge, bloque la possibilité de passer sans répondre
      props.setAuthorization(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["sujet"] = event.currentTarget.getAttribute("sujet");
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
    props.goForth(true);
  };

  /**
   * @description Affiche une grille de 3*3 qui propose des options sur la faune et la flore
   * @returns JSX component
   */
  const affichageFalse = () => {
    return (
      <Grid container spacing={2} style={{ maxWidth: "100%" }}>
        {/* Première ligne */}
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="conte legende"
          >
            <img
              src={CONTE_LEGENDE}
              alt="conte legende"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Conte et legende
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="Gastronomie"
          >
            <img
              src={GASTRONOMIE}
              alt="Gastronomie"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Gastronomie
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="Langue Régionale"
          >
            <img
              src={LANGUE_REGIONALE}
              alt="Langue Régionale"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Langue Régionale
          </Button>
        </Grid>
        {/* Deuxième ligne */}
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="Fête Traditionnelle"
          >
            <img
              src={FETE_TRADITIONNELLE}
              alt="Fête Traditionnelle"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Fête Traditionnelle
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="Marché"
          >
            <img
              src={MARCHE}
              alt="Marché"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Marché
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="Autre"
          >
            <img
              src={AUTRE}
              alt="Autre"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Autre
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Fragment>
      <Typography
        variant="body1"
        component="legend"
        style={{ marginLeft: 20, marginBottom: 20 }}
      >
        Veuillez sélectionner le sujet observé :
      </Typography>
      {/* Charge l'affichage conditionnel des 18 cases possibles */}
      {affichageFalse()}
    </Fragment>
  );
};

export default Step1;
